<template>
  <div class="editable-cell">
    <div
            v-if="editable"
            class="editable-cell-input-wrapper"
    >
      <a-input
              :value="value"
              style="width: 80px"
              @change="handleChange"
              @pressEnter="check"
      /><a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
    />
    </div>
    <div
            v-else
            class="editable-cell-text-wrapper"
    >
      {{ value === 0 || value ? value : ' ' }}
      <a-icon
              type="edit"
              class="editable-cell-icon"
              @click="edit"
      />
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      text: String|Number,
    },
    data () {
      return {
        value: this.text,
        editable: false,
      };
    },
    watch:{
      text(val){
        console.log('text change');
        console.log(val);
        if(this.editable == false){
          this.value = val;
        }
      }
    },
    methods: {
      handleChange (e) {
        const value = e.target.value;
        this.value = value;
      },
      check () {
        this.editable = false;
        this.$emit('change', this.value);
      },
      edit () {
        this.editable = true;
      },
    },
  };
</script>